export var getBrandUnit = function getBrandUnit(brand) {
  return (brand == null ? void 0 : brand.toLowerCase()) === 'kbb' ? 'my-kbb' : 'my-at';
};
export default getBrandUnit;